import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";

export const ServiceClassificationField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["3", "27", "35"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="serviceClassification"
        fullWidth
        label={
          t(translationPath + "serviceClassification") ||
          "serviceClassification"
        }
      />
      <FormHelperText>
        {t(translationPath + "serviceClassificationMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
